<template>
  <el-collapse v-model="activeNames" style="width: 100%">
    <cx-slider class="rect-active-slider" label="状态" :value.sync="activeType" :options="activeTypeOptions" />
    <template v-if="activeType === '1'">
      <widthAndHeightSize
          :widthVal.sync="width"
          :widthAuto.sync="widthAuto"
          :heightVal.sync="height"
          :heightAuto.sync="heightAuto"
          :widthFull.sync="widthFull"
          :disableWidthFull="false"
      />
      <el-collapse-item title="文字" name="1">
        <div class="content-item verticallyCenter mb12">
          <span class="mr12">展开文本</span>
          <div
              class="edit-div width-72"
              contenteditable="true"
              v-html="contentOpen"
              @blur="blurFunc($event, 1)"
              @focus="focusFunc"
          ></div>
        </div>
        <div class="content-item verticallyCenter mb12">
          <span class="mr12">收起文本</span>
          <div
              class="edit-div width-72"
              contenteditable="true"
              v-html="contentClose"
              @blur="blurFunc($event, 2)"
              @focus="focusFunc"
          ></div>
        </div>
        <text-setting-complex-update
            :fontFamily.sync="fontFamily"
            :fontSize.sync="fontSize"
            :fontWeight.sync="fontWeight"
            :fontStyle.sync="fontStyle"
            :textDecoration.sync="textDecoration"
            :lineHeight.sync="lineHeight"
            :lineHeightType.sync="lineHeightType"
            :letterSpacing.sync="letterSpacing"
            :activeArrangement.sync="activeArrangement"
            :writingMode.sync="writingMode"
            :textAlign.sync="textAlign"
            :activeArrangementOrder.sync="activeArrangementOrder"
            :isThemeColor.sync="textIsThemeColor"
            :colorArr.sync="color"
            :showOverflowSetting="false"
            :options="options"
        />
      </el-collapse-item>
      <el-collapse-item title="背景" name="2">
        <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" />
      </el-collapse-item>
      <el-collapse-item title="图标" name="3">
        <div class="content-item verticallyCenter">
          <el-checkbox v-model="showIcon">显示图标</el-checkbox>
        </div>
        <div v-if="showIcon" class="content-item mt8">
          <img-icon-upload
            class="mb16"
            :imgSrc.sync="iconSrc"
            :iconType.sync="iconType"
            :iconColor.sync="iconColor"
            :resInfo.sync="resInfo"
          />
          <div v-show="iconSrc.length" class="content-item mb16 verticallyCenter">
            <span class="mr16 fs14">位置</span>
            <el-radio-group v-model="iconPosition">
              <el-radio label="left">左</el-radio>
              <el-radio label="right">右</el-radio>
              <el-radio label="top">上</el-radio>
              <el-radio label="bottom">下</el-radio>
            </el-radio-group>
          </div>
          <div class="verticallyCenter mb16" v-if="iconType === 'icon'">
            <span class="mr16 fs14">颜色</span>
            <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
            </cx-color-picker>
          </div>
          <slider-and-input class="mb16" :value.sync="iconWidth" title="大小" :sliderMax="width" suffix="px" />
          <slider-and-input :value.sync="iconMargin" title="间距" :sliderMax="width" suffix="px" />
        </div>
      </el-collapse-item>
      <el-collapse-item title="边框" name="4">
        <div>
          <div class="content-item verticallyCenter mb8">
            <el-checkbox v-model="showBorder">显示边框</el-checkbox>
          </div>
          <cx-border
            v-if="showBorder"
            :borderWidth.sync="borderWidth"
            :borderStyle.sync="borderStyle"
            :borderColor.sync="borderColor"
            :borderIsThemeColor.sync="borderIsThemeColor"
          />
        </div>
        <div class="content-item mt12">
          <border-radius
            :borderTypeFlag.sync="borderTypeFlag"
            :borderRadius.sync="borderRadius"
            :borderTopLeftRadius.sync="borderTopLeftRadius"
            :borderTopRightRadius.sync="borderTopRightRadius"
            :borderBottomRightRadius.sync="borderBottomRightRadius"
            :borderBottomLeftRadius.sync="borderBottomLeftRadius"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item title="边距" name="5">
        <cx-padding
            :paddingTypeFlag.sync="paddingTypeFlag"
            :padding.sync="padding"
            :paddingTop.sync="paddingTop"
            :paddingRight.sync="paddingRight"
            :paddingBottom.sync="paddingBottom"
            :paddingLeft.sync="paddingLeft"
        />
      </el-collapse-item>
      <el-collapse-item title="更多" name="6">
        <div class="content">
          <div class="verticallyCenter">
            <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
          </div>
          <div class="content-item mt12">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('b')"></span>
            </div>
            <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
            />
          </div>
        </div>
      </el-collapse-item>
    </template>
    <template v-if="activeType === '2'">
      <el-checkbox class="padding12" v-model="hoverIsSame">同默认状态</el-checkbox>
      <template v-if="!hoverIsSame">
        <el-collapse-item title="文字" name="1">
          <text-setting-complex-update
              :fontFamily.sync="hoverFontFamily"
              :fontSize.sync="hoverFontSize"
              :fontWeight.sync="hoverFontWeight"
              :fontStyle.sync="hoverFontStyle"
              :textDecoration.sync="hoverTextDecoration"
              :lineHeight.sync="hoverLineHeight"
              :lineHeightType.sync="hoverLineHeightType"
              :letterSpacing.sync="hoverLetterSpacing"
              :activeArrangement.sync="hoverActiveArrangement"
              :writingMode.sync="hoverWritingMode"
              :textAlign.sync="hoverTextAlign"
              :activeArrangementOrder.sync="hoverActiveArrangementOrder"
              :isThemeColor.sync="hoverTextIsThemeColor"
              :colorArr.sync="hoverColor"
              :showOverflowSetting="false"
              :options="options"
          />
        </el-collapse-item>
        <el-collapse-item title="背景" name="2">
          <cx-background infoTips="支持上传图片" :background.sync="hoverBackground" imgType="10" />
        </el-collapse-item>
        <el-collapse-item title="边框" name="4">
          <div>
            <div class="content-item verticallyCenter mb12">
              <el-checkbox v-model="hoverShowBorder">显示边框</el-checkbox>
            </div>
            <cx-border
                v-if="hoverShowBorder"
                :borderWidth.sync="hoverBorderWidth"
                :borderStyle.sync="hoverBorderStyle"
                :borderColor.sync="hoverBorderColor"
                :borderIsThemeColor.sync="hoverBorderIsThemeColor"
            />
          </div>
          <div class="content-item mt12">
            <border-radius
                :borderTypeFlag.sync="hoverBorderTypeFlag"
                :borderRadius.sync="hoverBorderRadius"
                :borderTopLeftRadius.sync="hoverBorderTopLeftRadius"
                :borderTopRightRadius.sync="hoverBorderTopRightRadius"
                :borderBottomRightRadius.sync="hoverBorderBottomRightRadius"
                :borderBottomLeftRadius.sync="hoverBorderBottomLeftRadius"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="更多" name="5">
          <div class="checkbox_colorPicker_container">
            <span>阴影</span>
            <span
                v-show="hoverBorderShadowChecked"
                class="icon-portal-plus theme-color right-icon"
                @click="addBoxshadow('hoverB')"
            ></span>
          </div>
          <box-shadow
              v-show="hoverBorderShadowChecked"
              :boxShadowH.sync="hoverBoxShadowH"
              :boxShadowV.sync="hoverBoxShadowV"
              :boxShadowBlur.sync="hoverBoxShadowBlur"
              :boxShadowSpread.sync="hoverBoxShadowSpread"
              :boxShadowColor.sync="hoverBoxShadowColor"
          ></box-shadow>
        </el-collapse-item>
      </template>
    </template>
  </el-collapse>
</template>

<script>
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import rowColLayoutSize from "publicSetting/rowColLayoutSize"
import widthAndHeightSize from "publicSetting/widthAndHeightSize"
import { withMethodsHistoryCombine } from "utils/revork"
import CustomSubMenuSetting from "../render/customSubMenus/setting"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import rectPositionSet from "publicSetting/rect-position-set"
export default withMethodsHistoryCombine({
  name: "toggle-button-set",
  components: { elementPluginSetting, rowColLayoutSize, widthAndHeightSize, CustomSubMenuSetting, controlWidthAndSizeAndZindex, rectPositionSet },
  props: {
    options: Object,
    buttonType: String
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2", "3", "4", "5", "6"],
      collapseActiveNames: ["1", "2"],
      allCollapseNames: ["1", "2", "3", "4", "5", "6"],
      sliderMax: 100,
      activeTypeOptions: [
        { value: "1", title: "默认" },
        { value: "2", title: "悬浮" },
      ],
      activeType: "1",
      hoverBorderShadowChecked: true,
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions() {
      return this.options[this.buttonType] || {}
    },

    widthAuto: {
      get() {
        return this.getOptions.hasOwnProperty("widthAuto") ? this.getOptions.widthAuto : true
      },
      set(newVal) {
        this.changeOptions(newVal, "widthAuto", false)
      }
    },
    width: {
      get() {
        return this.getOptions.hasOwnProperty("width") ? this.getOptions.width : 42
      },
      set(newVal) {
        this.changeOptions(newVal, "width", false)
      }
    },
    widthFull: {
      get() {
        return this.getOptions.hasOwnProperty("widthFull") ? this.getOptions.widthFull : false
      },
      set(newVal) {
        this.changeOptions(newVal, "widthFull", false)
      }
    },
    heightAuto: {
      get() {
        return this.getOptions.hasOwnProperty("heightAuto") ? this.getOptions.heightAuto : true
      },
      set(newVal) {
        this.changeOptions(newVal, "heightAuto", false)
      }
    },
    height: {
      get() {
        return this.getOptions.hasOwnProperty("height") ? this.getOptions.height : 24
      },
      set(newVal) {
        this.changeOptions(newVal, "height", false)
      }
    },

    contentOpen: {
      get() {
        let txt = this.getOptions.contentOpen || "展开"
        let txt1 = txt?.replace(/(<br>)*$/g, "") //替换末尾换行符
        return txt1
      },
      set(newVal) {
        newVal = String(newVal).replace(/<[^>]+>/g, "<br>")
        this.changeOptions(newVal, "contentOpen", false)
      }
    },
    contentClose: {
      get() {
        let txt = this.getOptions.contentClose || "收起"
        let txt1 = txt?.replace(/(<br>)*$/g, "") //替换末尾换行符
        return txt1
      },
      set(newVal) {
        newVal = String(newVal).replace(/<[^>]+>/g, "<br>")
        this.changeOptions(newVal, "contentClose", false)
      }
    },
    fontFamily: {
      get() {
        return this.getOptions.hasOwnProperty("fontFamily") ? this.getOptions.fontFamily : "sans-serif"
      },
      set(newVal) {
        this.changeOptions(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.getOptions.hasOwnProperty("fontSize") ? this.getOptions.fontSize : 13
      },
      set(newVal) {
        this.changeOptions(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.getOptions.hasOwnProperty("fontWeight") ? this.getOptions.fontWeight : 400
      },
      set(newVal) {
        this.changeOptions(newVal, "fontWeight", false)
      }
    },
    fontStyle: {
      get() {
        return this.getOptions.hasOwnProperty("fontStyle") ? this.getOptions.fontStyle : "normal"
      },
      set(newVal) {
        this.changeOptions(newVal, "fontStyle", false)
      }
    },
    textDecoration: {
      get() {
        return this.getOptions.hasOwnProperty("textDecoration") ? this.getOptions.textDecoration : "none"
      },
      set(newVal) {
        this.changeOptions(newVal, "textDecoration", false)
      }
    },
    lineHeight: {
      get() {
        return this.getOptions.hasOwnProperty("lineHeight") ? this.getOptions.lineHeight : 24
      },
      set(newVal) {
        this.changeOptions(newVal, "lineHeight", false)
      }
    },
    lineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "lineHeightType", "lineHeightType", "px")
      },
      set(newVal) {
        this.changeOptions(newVal, "lineHeightType", false)
      }
    },
    letterSpacing: {
      get() {
        return this.getOptions.hasOwnProperty("letterSpacing") ? this.getOptions.letterSpacing : 0
      },
      set(newVal) {
        this.changeOptions(newVal, "letterSpacing", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.getOptions.letterSpacingType || "px"
      },
      set(newVal) {
        this.changeOptions(newVal, "letterSpacingType", false)
      }
    },

    activeArrangement: {
      get() {
        return this.getOptions.hasOwnProperty("textAlign") ? this.getOptions.textAlign : "center"
      },
      set(newVal) {
        this.changeOptions(newVal, "textAlign", false)
      }
    },
    writingMode: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "writingMode", "writingMode", "horizontal-tb")
      },
      set(newVal) {
        this.changeOptions(newVal, "writingMode", false)
      }
    },
    textAlign: {
      get() {
        return this.getOptions.hasOwnProperty("textAlign") ? this.getOptions.textAlign : "center"
      },
      set(newVal) {
        this.changeOptions(newVal, "textAlign", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingMode = val
      }
    },
    textIsThemeColor: {
      get() {
        return this.getOptions.textIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "textIsThemeColor", false)
      }
    },
    color: {
      get() {
        return this.getOptions.color || "#B0B0B2"
      },
      set(newVal) {
        this.changeOptions(newVal, "color", false)
      }
    },
    background: {
      get() {
        let background = this.getOptions.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.getOptions.background
        }
        let newbackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.bgColorIsThemeColor,
            color: this.getOptions.bgColor
          }
        ]
        this.changeOptions(newbackground, "background", false, false, false, true)
        return newbackground
      },
      set(newVal) {
        this.changeOptions(newVal, "background", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.getOptions.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "bgColorIsThemeColor", false)
      }
    },
    bgColor: {
      get() {
        return this.getOptions.bgColor || "rgba(255, 255, 255, 0)"
      },
      set(newVal) {
        this.changeOptions(newVal, "bgColor", false)
      }
    },

    showIcon: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "showIcon", "showIcon", true)
      },
      set(newVal) {
        this.changeOptions(newVal, "showIcon", false)
      }
    },
    iconSrc: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "iconSrc", "iconSrc", "342d06f938721111ed0b1a4513396451785f")
      },
      set(newVal) {
        this.changeOptions(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "iconType", "iconType", "icon")
      },
      set(newVal) {
        this.changeOptions(newVal, "iconType", false)
      }
    },
    iconWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "iconWidth", "iconWidth", 14)
      },
      set(newVal) {
        this.changeOptions(newVal, "iconWidth", false)
      }
    },
    iconMargin: {
      get() {
        return this.getOptions.iconMargin || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "iconColor", "iconColor", "#999999")
      },
      set(newVal) {
        this.changeOptions(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.getOptions.iconColorIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "iconColorIsThemeColor", false)
      }
    },
    iconPosition: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "iconPosition", "iconPosition", "right")
      },
      set(newVal) {
        this.changeOptions(newVal, "iconPosition", false)
      }
    },
    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "resInfo", "resInfo", {})
      },
      set(newVal) {
        this.changeOptions(newVal, "resInfo", false)
      }
    },

    showBorder: {
      get() {
        let showBorder = false
        if (this.getOptions.showBorder === undefined) {
          if (Array.isArray(this.getOptions.borderWidth)) {
            let allZero = true
            for (let i = 0; i < this.getOptions.borderWidth.length; i++) {
              if (this.getOptions.borderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.getOptions.borderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.getOptions.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.borderWidth) {
          this.changeOptions([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.changeOptions(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.getOptions.borderWidth || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "borderWidth", false)
      }
    },
    borderStyle: {
      get() {
        return this.getOptions.borderStyle || "solid"
      },
      set(newVal) {
        this.changeOptions(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.getOptions.borderColor || "rgba(255, 255, 255, 0)"
      },
      set(newVal) {
        this.changeOptions(newVal, "borderColor", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.getOptions.borderIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "borderIsThemeColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        return this.getOptions.borderTypeFlag || 2
      },
      set(newVal) {
        this.changeOptions(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
            this.getOptions,
            "borderRadius",
            "borderRadius",
            this.borderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.borderTopLeftRadius = newVal
          this.borderTopRightRadius = newVal
          this.borderBottomLeftRadius = newVal
          this.borderBottomRightRadius = newVal
        }
        this.changeOptions(newVal, "borderRadius", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.getOptions.borderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.changeOptions(
              [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
              [
                "borderTopRightRadius",
                "borderBottomRightRadius",
                "borderBottomLeftRadius",
                "borderTopLeftRadius"
              ],
              false
          )
          this.changeOptions(parseInt(newVal), "borderBottomRightRadius", false)
          this.changeOptions(parseInt(newVal), "borderBottomLeftRadius", false)
        } else {
          this.changeOptions(newVal, "borderTopLeftRadius", false)
        }
      }
    },
    borderTopRightRadius: {
      get() {
        return this.getOptions.borderTopRightRadius || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.getOptions.borderBottomRightRadius || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.getOptions.borderBottomLeftRadius || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "borderBottomLeftRadius", false)
      }
    },
    paddingTypeFlag: {
      get() {
        let buttonType = 2
        if (
            ((this.paddingTop === this.paddingRight) === this.paddingLeft) ===
            this.paddingBottom
        ) {
          buttonType = 1
        }
        return this.getOptions.paddingTypeFlag || buttonType
      },
      set(newVal) {
        this.changeOptions(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "padding", "padding", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "paddingBottom", false)
      }
    },
    opacity: {
      get() {
        return this.getOptions.hasOwnProperty("opacity") ? parseInt(this.getOptions.opacity * 100) : 100
      },
      set(newVal) {
        this.changeOptions(newVal / 100, "opacity", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.getOptions.boxShadowColor || ""
      },
      set(newVal) {
        this.changeOptions(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.getOptions.boxShadowH || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.getOptions.boxShadowV || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.getOptions.boxShadowBlur || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.getOptions.boxShadowSpread || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "boxShadowSpread", false)
      }
    },
    hoverFontFamily: {
      get() {
        return this.getOptions.hoverFontFamily || "sans-serif"
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverFontFamily", false)
      }
    },
    hoverFontSize: {
      get() {
        return this.getOptions.hasOwnProperty("hoverFontSize") ? this.getOptions.hoverFontSize : 13
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverFontSize", false)
      }
    },
    hoverFontWeight: {
      get() {
        return this.getOptions.hoverFontWeight || 400
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverFontWeight", false)
      }
    },
    hoverFontStyle: {
      get() {
        return this.getOptions.hoverFontStyle || "normal"
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverFontStyle", false)
      }
    },
    hoverTextDecoration: {
      get() {
        return this.getOptions.hoverTextDecoration || "none"
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverTextDecoration", false)
      }
    },
    hoverLineHeight: {
      get() {
        return this.getOptions.hasOwnProperty("hoverLineHeight") ? this.getOptions.hoverLineHeight : 24
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverLineHeight", false)
      }
    },
    hoverLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "hoverLineHeightType", "hoverLineHeightType", "px")
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverLineHeightType", false)
      }
    },
    hoverLetterSpacing: {
      get() {
        return this.getOptions.hoverLetterSpacing || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverLetterSpacing", false)
      }
    },
    hoverActiveArrangement: {
      get() {
        return this.getOptions.hoverTextAlign || "center"
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverActiveArrangement", false)
      }
    },
    hoverWritingMode: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "hoverWritingMode", "hoverWritingMode", "horizontal-tb")
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverWritingMode", false)
      }
    },
    hoverTextAlign: {
      get() {
        return this.getOptions.hoverTextAlign || "center"
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverTextAlign", false)
      }
    },
    hoverActiveArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.hoverWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.hoverWritingMode = val
      }
    },
    hoverTextIsThemeColor: {
      get() {
        return this.getOptions.hoverTextIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverTextIsThemeColor", false)
      }
    },
    hoverColor: {
      get() {
        return this.getOptions.hoverColor || "#B0B0B2"
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverColor", false)
      }
    },

    hoverBackground: {
      get() {
        let hoverBackground = this.getOptions.hoverBackground
        if (hoverBackground && Array.isArray(hoverBackground) && hoverBackground.length > 0) {
          return this.getOptions.hoverBackground
        }
        let newHoverBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.hoverBgColorIsThemeColor,
            color: this.getOptions.hoverBgColor
          }
        ]
        this.changeOptions(newHoverBackground, "hoverBackground", false, false, false, true)
        return newHoverBackground
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBackground", false)
      }
    },
    hoverBgColorIsThemeColor: {
      get() {
        return this.getOptions.hoverBgColorIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBgColorIsThemeColor", false)
      }
    },
    hoverBgColor: {
      get() {
        return this.getOptions.hoverBgColor || "rgba(255, 255, 255, 0)"
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBgColor", false)
      }
    },
    hoverShowBorder: {
      get() {
        let showBorder = false
        if (this.getOptions.hoverShowBorder === undefined) {
          if (Array.isArray(this.getOptions.hoverBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.getOptions.hoverBorderWidth.length; i++) {
              if (this.getOptions.hoverBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.getOptions.hoverBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.getOptions.hoverShowBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.hoverBorderWidth) {
          this.changeOptions([1, newVal], ["hoverBorderWidth", "hoverShowBorder"], false)
        } else {
          this.changeOptions(newVal, "hoverShowBorder", false)
        }
      }
    },
    hoverBorderWidth: {
      get() {
        return this.getOptions.hoverBorderWidth || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBorderWidth", false)
      }
    },
    hoverBorderStyle: {
      get() {
        return this.getOptions.hoverBorderStyle || "solid"
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBorderStyle", false)
      }
    },
    hoverBorderColor: {
      get() {
        return this.getOptions.hoverBorderColor || ""
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBorderColor", false)
      }
    },
    hoverBorderIsThemeColor: {
      get() {
        return this.getOptions.hoverBorderIsThemeColor || false
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBorderIsThemeColor", false)
      }
    },
    hoverBorderTypeFlag: {
      get() {
        return this.getOptions.hoverBorderTypeFlag || 2
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBorderTypeFlag", false)
      }
    },
    hoverBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "hoverBorderRadius", "hoverBorderRadius", this.hoverBorderTopLeftRadius)
      },
      set(newVal) {
        if (this.hoverBorderTypeFlag === 2) {
          this.changeOptions(
              [newVal, newVal, newVal, newVal, newVal],
              [
                "hoverBorderTopLeftRadius",
                "hoverBorderTopRightRadius",
                "hoverBorderBottomLeftRadius",
                "hoverBorderBottomRightRadius",
                "hoverBorderRadius"
              ],
              false
          )
        } else {
          this.changeOptions(newVal, "hoverBorderRadius", false)
        }
      }
    },
    hoverBorderTopLeftRadius: {
      get() {
        return this.getOptions.hoverBorderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.hoverBorderTypeFlag === 2) {
          this.changeOptions(
              [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
              ["hoverBorderTopRightRadius", "hoverBorderBottomRightRadius", "hoverBorderBottomLeftRadius", "hoverBorderTopLeftRadius"],
              false
          )
        } else {
          this.changeOptions(newVal, "hoverBorderTopLeftRadius", false)
        }
      }
    },
    hoverBorderTopRightRadius: {
      get() {
        return this.getOptions.hoverBorderTopRightRadius || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBorderTopRightRadius", false)
      }
    },
    hoverBorderBottomRightRadius: {
      get() {
        return this.getOptions.hoverBorderBottomRightRadius || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBorderBottomRightRadius", false)
      }
    },
    hoverBorderBottomLeftRadius: {
      get() {
        return this.getOptions.hoverBorderBottomLeftRadius || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBorderBottomLeftRadius", false)
      }
    },
    hoverPaddingTypeFlag: {
      get() {
        let defaultType = 2
        if (
            ((this.hoverPaddingTop === this.hoverPaddingRight) === this.hoverPaddingLeft) ===
            this.hoverPaddingBottom
        ) {
          defaultType = 1
        }
        return this.getOptions.hoverPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverPaddingTypeFlag", false)
      }
    },
    hoverPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "hoverPadding", "hoverPadding", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverPadding", false)
      }
    },
    hoverPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "hoverPaddingTop", "hoverPaddingTop", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverPaddingTop", false)
      }
    },
    hoverPaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "hoverPaddingRight", "hoverPaddingRight", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverPaddingRight", false)
      }
    },
    hoverPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "hoverPaddingLeft", "hoverPaddingLeft", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverPaddingLeft", false)
      }
    },
    hoverPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "hoverPaddingBottom", "hoverPaddingBottom", 0)
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverPaddingBottom", false)
      }
    },
    hoverBoxShadowColor: {
      get() {
        return this.getOptions.hoverBoxShadowColor || ""
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBoxShadowColor", false)
      }
    },
    hoverBoxShadowH: {
      get() {
        return this.getOptions.hoverBoxShadowH || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBoxShadowH", false)
      }
    },
    hoverBoxShadowV: {
      get() {
        return this.getOptions.hoverBoxShadowV || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBoxShadowV", false)
      }
    },
    hoverBoxShadowBlur: {
      get() {
        return this.getOptions.hoverBoxShadowBlur || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBoxShadowBlur", false)
      }
    },
    hoverBoxShadowSpread: {
      get() {
        return this.getOptions.hoverBoxShadowSpread || 0
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverBoxShadowSpread", false)
      }
    },
    hoverIsSame: {
      get() {
        return this.getOptions.hasOwnProperty("hoverIsSame") ? this.getOptions.hoverIsSame : true
      },
      set(newVal) {
        this.changeOptions(newVal, "hoverIsSame", false)
      }
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })

  },
  methods: {
    changeOptions(newVal, name) {
      console.log('newVal :>>changeOptions>>>',newVal,name,this.options[this.buttonType]);
      if (!this.options[this.buttonType]) this.$changeOptionsEV({}, this.buttonType, false)
      if (Array.isArray(name) && name.length) {
        for (let i = 0; i < newVal.length; i++) {
          this.$changeOptionsEV(newVal[i], name[i], true, this.buttonType, this.ids)
        }
      } else {
        this.$changeOptionsEV(newVal, name, true, this.buttonType, this.ids)
      }
    },
    addBoxshadow(prefix) {
      if (!Array.isArray(this[`${prefix}oxShadowH`])) {
        this[`${prefix}oxShadowH`] = [this[`${prefix}oxShadowH`]]
        this[`${prefix}oxShadowV`] = [this[`${prefix}oxShadowV`]]
        this[`${prefix}oxShadowBlur`] = [this[`${prefix}oxShadowBlur`]]
        this[`${prefix}oxShadowSpread`] = [this[`${prefix}oxShadowSpread`]]
        this[`${prefix}oxShadowColor`] = [this[`${prefix}oxShadowColor`]]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this[`${prefix}oxShadowH`]))
      let boxShadowV = JSON.parse(JSON.stringify(this[`${prefix}oxShadowV`]))
      let boxShadowBlur = JSON.parse(JSON.stringify(this[`${prefix}oxShadowBlur`]))
      let boxShadowSpread = JSON.parse(JSON.stringify(this[`${prefix}oxShadowSpread`]))
      let boxShadowColor = JSON.parse(JSON.stringify(this[`${prefix}oxShadowColor`]))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this[`${prefix}oxShadowH`] = boxShadowH
      this[`${prefix}oxShadowV`] = boxShadowV
      this[`${prefix}oxShadowBlur`] = boxShadowBlur
      this[`${prefix}oxShadowSpread`] = boxShadowSpread
      this[`${prefix}oxShadowColor`] = boxShadowColor
    },
    changeFilter(val, flag) {
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
    },
    blurFunc($event, type) {
      if (type === 2) {
        this.contentClose = $event.target.innerHTML
      } else {
        this.contentOpen = $event.target.innerHTML
      }
      sessionStorage.removeItem("isInputFocus")
    },
    focusFunc() {
      sessionStorage.setItem("isInputFocus", true)
    },
  }
})
</script>

<style scoped lang="scss">
.custom-title-color {
  width: calc(100% - 76px);
}

.multiFilter-options-setting .width-type-tab ::v-deep .el-tabs .el-tabs__content {
  display: none;
}

.multiFilter-options-setting .width-type-tab ::v-deep .el-tabs .el-tabs__header {
  margin-left: 0;
  margin-right: 0;
}

.multiFilter-options-setting .tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}

.multiFilter-options-setting .tips-btn:hover {
  color: var(--themeColor);
}


::v-deep .filter-state-set .el-tabs__content {
  padding-bottom: 0;
}

.navBox {
  height: 32px;
  padding: 4px 4px 4px 12px;
  border-radius: 4px;
  background: var(--inputBg);
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background: var(--inputNuberHoverThemeBgColor);
  }

  .navTitle {
    font-size: 13px;
    font-weight: 600;
    color: var(--textColor);
  }

  .navLabel {
    color: var(--thirdTextColor);
    display: flex;
  }

  .navIcon {
    font-size: 20px;
  }

  &:hover {
    cursor: pointer;
  }
}

.navBackBox {
  height: 38px;
  padding-left: 12px;
  display: flex;
  gap: 4px;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  .navBackIcon {
    font-size: 24px;
  }

  .navBackTitle {
    font-size: 14px;
    font-weight: 600;
    color: var(--textColor);
  }
}

.checked-label {
  padding: 8px 12px 16px 12px;
}

.option-choose-container {
  border-radius: 4px;
  padding: 5px 12px;
  background-color: var(--cardBgColor);
  border: 1px solid var(--sliderBackGround);
  margin-top: 8px;
}

.row-set {

  .btn-wrapper {
    flex: 1;
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;
    margin-left: 12px;

    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      cursor: pointer;
      color: var(--subTextColor);

      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }

      &:not(.disabled):hover {
        color: var(--themeColor);
      }

      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}
.padding12 {
  padding: 0px 12px 12px;
}
.edit-div {
  width: 100%;
  background-color: var(--inputBackGround);
  border: var(--inputBorder);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 4px;
}
.edit-div:focus {
  outline: none;
  border: 1px solid var(--themeColor);
}
.edit-div.width-72{
  width: calc(100% - 72px);
}
.quick-set-switch {
  width: 32px;
  height: 32px;
  text-align: center;
  padding: 3px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 8px;
  background-color: #f3f3f3;
  color: var(--iconColor);
  cursor: pointer;
}

.quick-set-switch .item {
  display: inline-block;
  width: 100%;
  line-height: 26px;
  border-radius: 4px;
}

.quick-set-switch.open .item {
  color: var(--themeColor);
  background-color: #fff;
  border: 2px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
}

.quick-set-switch:hover {
  color: #000;
}
</style>
